import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import el from './el.json'
import en from './en.json'
import es from './es.json'

export const LOCALE_STORAGE_KEY = 'label-designer.locale'
export type SupportedLocale = 'en' | 'es' | 'el'

export const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'es', 'el']

export function readStoredLocale(): SupportedLocale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored === 'en' || stored === 'es' || stored === 'el') return stored
  } catch {
    // ignore
  }
  return 'en'
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    el: { translation: el },
  },
  lng: readStoredLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export function changeLocale(next: SupportedLocale) {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, next)
  } catch {
    // ignore
  }
  void i18n.changeLanguage(next)
}

/**
 * Normalizes a BCP-47-ish locale tag (Odoo's `res.lang` codes like `es_AR`,
 * or a browser tag like `en-US`) down to its primary language subtag and
 * validates it against `SUPPORTED_LOCALES`. Falls back to `'en'` for
 * missing input or subtags this build doesn't ship translations for.
 */
export function normalizeLocale(raw: string | null | undefined): SupportedLocale {
  if (!raw) return 'en'
  const primary = raw.split(/[-_]/)[0]?.toLowerCase() ?? ''
  return (SUPPORTED_LOCALES as string[]).includes(primary)
    ? (primary as SupportedLocale)
    : 'en'
}

export default i18n
